<template>
    <div>
        <education-quick-filter
            v-model="selectedFilters['quickFilters']"
            :filter="filtersOptions"
        ></education-quick-filter>
    </div>
</template>

<script>
import EducationQuickFilter from '@/components/education/education-quick-filter';

export default {
    components: {
        EducationQuickFilter
    },
    props: {
        filtersOptions: {
            type: Object,
            default() {
                return {};
            }
        },
        value: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            selectedFilters: {}
        };
    },

    watch: {
        selectedFilters: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    }
};
</script>
